import { useSelector } from "react-redux";
import { getCurrencyNumberOfDigits } from "../services/helpers/customization-helper";
import { truncateToDecimals } from "../services/helpers/number-formatter";
import translate from "../services/translation/lang";
import Currency from "./Currency";
import Tooltip from "@mui/material/Tooltip";

export default function Header() {

  const turboMode = useSelector((state) => state.turboMode);
  const { balance } = useSelector((s) => s.balance);
  const decimalPlaces = getCurrencyNumberOfDigits() ?? 2;
  const truncatedBalance = truncateToDecimals(balance, decimalPlaces);
  const truncatedTurboBalance = truncateToDecimals(turboMode.value, decimalPlaces);
  const login = useSelector((state) => state.login);

  const logo = "img/logo.png";
  return (
    <div className="header">
      <img className="logo" src={logo} alt="by-elbet" />

      <div className="header-balance-holder">
       <div className="header-balance-title text-capitalize">{translate("balance")}</div>
       <Tooltip title={balance} placement="right">
          <div className="balance-holder">
            <div className="currency-symbol">
              <Currency>{login?.player_data?.currency_code}</Currency>
            </div>
            <div className="balance-value">{truncatedBalance.toFixed(decimalPlaces)}</div>
          </div>
        </Tooltip>
      </div>
      <div className="header-balance-holder">
       <div className="header-balance-title ">{translate("turbo_balance")}</div>
          <div className="balance-holder">
            <div className="currency-symbol">
              <Currency>{login?.player_data?.currency_code}</Currency>
            </div>
            <div className="balance-value">{truncatedTurboBalance.toFixed(decimalPlaces)}</div>
          </div>
      </div>

    </div>
  );
}
